import styles from '@/styles/components/controls/Textarea.module.scss'
import { InputInvalid } from '@/components/icons/InputInvalid'
import { InputValid } from '@/components/icons/InputValid'
import { forwardRef } from 'react'
import cn from 'classnames'

interface Props {
  label?: string,
  description?: string,
  placeholder?: string,
  error?: string,
  name?: string
  valid?: boolean,
  invalid?: boolean,
  className?: string,
  dark?: boolean,
  value?: string,
  rows?: number,
  onChange?: (event: {
    target: any
    type?: any
  }) => Promise<void | boolean>
  onBlur?: (event: {
    target: any
    type?: any
  }) => Promise<void | boolean>
}

export const Textarea = forwardRef<HTMLTextAreaElement, Props>(({
  label = '',
  description = '',
  placeholder = '',
  className = '',
  error,
  value = undefined,
  dark = true,
  valid,
  rows = 5,
  name,
  onChange,
  onBlur
}, ref) => {
  const controlClasses = cn({
    [styles.control_textarea]: true,
  })

  const labelClasses = cn({
    [styles.control_textarea_label]: true,
    [styles.control_textarea_label_dark]: dark
  })

  const descriptionClasses = cn({
    [styles.control_textarea_description]: true
  })

  const textareaClasses = cn({
    [styles.control_textarea_input]: true,
    [styles.control_textarea_input_dark]: dark,
    [styles.control_textarea_invalid]: !!error,
    [styles.control_textarea_valid]: valid
  })

  return (
    <div className={`${controlClasses} ${className}`}>
      {label && <label className={labelClasses}>{label}</label>}
      {description && <p className={descriptionClasses}>{description}</p>}
      <div className={styles.control_textarea_wrapper}>
        <textarea cols={30} rows={rows} placeholder={placeholder} className={textareaClasses} onChange={onChange} value={value} onBlur={onBlur} name={name} ref={ref}></textarea>
        {valid && <InputValid className={styles.control_textarea_icon} />}
        {!!error && <InputInvalid className={styles.control_textarea_icon}/>}
      </div>
      {error && <span className={styles.control_textarea_error}>{error}</span>}
    </div>
  )
})

Textarea.displayName = 'Textarea'
